import React from "react";
import Icon from "~/components/ui/Icon"
import { Dispatch, SetStateAction, useEffect, useState } from "react"

interface GlossaryMenuProps {
  letters: string[]
  categories: (string | undefined)[]
  selectedCategory: string
  setSelectedCategory: Dispatch<SetStateAction<string>>
  valueSearch: string
  setValueSearch: Dispatch<SetStateAction<string>>
  activeLetter: string
}

const scrollToTop = () => scrollTo({ top: 0, behavior: 'smooth' })

export default function GlossaryMenu(
  {
    letters,
    categories,
    selectedCategory,
    setSelectedCategory,
    valueSearch,
    setValueSearch,
    activeLetter,
  }: GlossaryMenuProps,
) {
  const [showOptions, setShowOptions] = useState(false)

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value
    setValueSearch(value)
    setSelectedCategory('')
  }

  const closeSelectCategories = () => setShowOptions(false)
  const openSelectCategories = () => setShowOptions(true)

  const handleCategory = (category: string) => {
    setValueSearch('')
    setSelectedCategory(category === 'Todas as categorias' ? '' : category)
    closeSelectCategories()
    scrollToTop()
  }

  useEffect(() => {
    if (!showOptions) return
    const close = () => setShowOptions(false)
    document.addEventListener('click', close)
    return () => document.removeEventListener('click', close)
  }, [showOptions])

  return (
    <div className='z-10 w-full flex flex-col lg:flex-row gap-3 lg:gap-8 mx-auto px-4 py-4 lg:py-2.5 bg-white border-b border-[#F6F5F0] sticky top-0'>
      {/* {categories?.length > 1 && (
        <div className='w-full max-w-[calc(50%-12px)] lg:max-w-72 lg:min-w-72 h-11 relative'>
          <div
            className='h-full flex items-center justify-between gap-1 px-3 sm:px-4 rounded-lg bg-white border border-[#CBCBCB] cursor-pointer relative z-10'
            onClick={openSelectCategories}
          >
            <span className='text-sm text-[#585858] select-none first-letter:capitalize'>
              {!selectedCategory ? categories[0] : selectedCategory}
            </span>
            <Icon
              id='GlossaryArrow'
              width={14}
              height={8}
              className={`text-[#361318] duration-300 ${showOptions ? 'rotate-180' : 'rotate-0'}`}
              strokeWidth={1}
            />
          </div>

          {!!showOptions && (
            <ul className='w-full max-h-[272px] flex flex-col absolute top-9 pt-2 bg-white overflow-y-auto shadow-lg shadow-[#00000019] rounded-b-lg'>
              {categories.map((category) => {
                if (!category) return null
                return (
                  <li
                    key={category}
                    onClick={() => handleCategory(category)}
                    className='bg-white duration-300 text-sm text-[#585858] select-none px-4 py-3 hover:bg-[#F9F9F9] cursor-pointer first-letter:capitalize'
                  >
                    {category}
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      )} */}

      <div className='flex h-fit lg:max-w-[calc(100%-64px-576px)]'>
        <ul className='flex overflow-x-auto snap-mandatory gap-0.5 px-[5px] py-[2px] bg-[#F9F9F9] rounded-lg scrollbar-primary-brands'>
          {letters.map((letter) => {
            return (
              <li key={letter}>
                <a
                  id={`letter-${letter}`}
                  className={`w-10 min-w-10 h-10 flex items-center justify-center duration-300 rounded-lg font-bold font-sans border hover:border-red-wine select-none ${
                    letter === activeLetter
                      ? 'text-white bg-red-wine border-red-wine'
                      : 'text-red-wine bg-[#F9F9F9] border-[#F9F9F9]'
                  }`}
                  href={`#${letter}`}
                >
                  {letter}
                </a>
              </li>
            )
          })}
        </ul>
      </div>

      <div className='absolute top-4 right-4 z-20 lg:static w-full max-w-[calc(50%-12px)] lg:max-w-72 lg:min-w-72 h-11 focus-within:border-[#CBCBCB] hover:border-[#CBCBCB] px-3 sm:px-4 justify-between flex items-center bg-white duration-300 border border-[#F6F6F6] rounded-lg'>
        <input
          className='bg-transparent w-full font-sans text-[#585858] placeholder:text-[#585858] text-sm outline-0 pr-2'
          placeholder='Qual marca você procura?'
          onClick={scrollToTop}
          onChange={handleSearch}
          value={valueSearch}
        />

        <button className='h-full' aria-label='Search'>
          <Icon id='GlossarySearch' size={18} strokeWidth={1} />
        </button>
      </div>
    </div>
  )
}
